'use client';

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
// Frozen so the shared singleton returned to every out-of-provider consumer can
// never be mutated into a poisoned default for the others.
const EMPTY_SLOTS = Object.freeze({
  slots: Object.freeze({}),
  slotProps: Object.freeze({})
});

/**
 * Distributes the flat `ChatBox` slots/slotProps to the message-rendering
 * pipeline (`ChatBoxContent`, `DefaultMessageItem`, `ChatMessageGroup`) without
 * prop-drilling. `null` (no provider) means "not inside a ChatBox" — standalone
 * components fall back to their own `slots` prop.
 */
export const ChatSlotsContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") ChatSlotsContext.displayName = "ChatSlotsContext";
if (process.env.NODE_ENV !== 'production') {
  ChatSlotsContext.displayName = 'ChatSlotsContext';
}
export function ChatSlotsProvider(props) {
  const {
    slots,
    slotProps,
    children
  } = props;
  const value = React.useMemo(() => ({
    slots: slots ?? {},
    slotProps: slotProps ?? {}
  }), [slots, slotProps]);
  return /*#__PURE__*/_jsx(ChatSlotsContext.Provider, {
    value: value,
    children: children
  });
}

/**
 * Reads the ambient ChatBox slots. Returns empty maps when there is no
 * `ChatSlotsProvider` ancestor (e.g. a standalone styled component).
 */
export function useChatSlots() {
  return React.useContext(ChatSlotsContext) ?? EMPTY_SLOTS;
}